import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector, useDispatch } from 'react-redux';
import { toggleChangePasswordModalOpen } from '../actions/AppActions';
import ChangePasswordModalContainer from '../containers/ChangePasswordModalContainer';
import ForgotPasswordModalContainer from '../containers/ForgotPasswordModalContainer';
import Subsection from 'settings-ui-lib/components/Subsection';
import SettingsRowButton from 'settings-ui-lib/components/SettingsRowButton';
import { getFetchProfileRequestStatus } from '../selectors/RequestStatusSelector';
import { getIsUserImpersonated } from '../selectors/AuthSelector';
import { anyRequestsFailed } from '../utils/requestUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useDisabledStatus = () => {
  const isUserImpersonated = useSelector(getIsUserImpersonated);
  const profileRequestStatus = useSelector(getFetchProfileRequestStatus);
  const haveAnyRequestsFailed = anyRequestsFailed(profileRequestStatus);
  if (isUserImpersonated) {
    return {
      disabled: true,
      reason: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.tooltips.userImpersonation"
      })
    };
  }
  if (haveAnyRequestsFailed) {
    return {
      disabled: true,
      reason: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "password.disabledTooltip"
      })
    };
  }
  return {
    disabled: false
  };
};
const Password = () => {
  const {
    updatedAt
  } = useSelector(state => state.password);
  const {
    disabled,
    reason
  } = useDisabledStatus();
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs(Subsection, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "password.title"
    }),
    children: [/*#__PURE__*/_jsx(SettingsRowButton, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "password.reset",
        "data-test-id": "reset-password-settings-button"
      }),
      onClick: () => dispatch(toggleChangePasswordModalOpen()),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "password.description",
        options: {
          resetDate: new Date(updatedAt).toLocaleDateString()
        }
      }),
      disabledTooltipTitle: reason,
      disabled: disabled
    }), /*#__PURE__*/_jsx(ChangePasswordModalContainer, {}), /*#__PURE__*/_jsx(ForgotPasswordModalContainer, {})]
  });
};
export default Password;